export default {
  rootFontSizePx: 13.2,
};
